import { ProfilePageContainer } from "@/components/container/profile-page-container";
import MealCreatingProgress from "@/features/go-to/components/meal-creating-progress";
import { useCreatePlan } from "@/hooks/requests/plan/use-create-plan";
import { useToast } from "@/hooks/ui/use-toast";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { useIonRouter } from "@ionic/react";
import { useEffect } from "react";

export default function ProfilingCreating() {
  const navigation = useIonRouter();
  const { info } = useStepRouteInfo();
  const { showError } = useToast();
  const { updatePlanAsync } = useCreatePlan();

  useEffect(() => {
    updatePlanAsync()
      .then(() => {
        navigation.push(info?.nextPath ?? "", "none");
      })
      .catch((error) => {
        showError(error.message);
      });
  }, []);

  return (
    <ProfilePageContainer
      showToolbar={false}
      className="h-full flex flex-col items-center justify-center"
    >
      <MealCreatingProgress />
    </ProfilePageContainer>
  );
}
